import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'

import { deselectAllBillableBookings } from '../../../actions/invoices'
import { ReactComponent as CheckIcon } from './check.svg'
import { ReactComponent as RemoveIcon } from './remove.svg'
import styles from './SelectedBookingsBar.module.scss'

export const SelectAllBar = ({ count, handleSelectAll }) => {
  return (
    <div className={styles.bar}>
      <div className={styles.wrapper}>
        <div className={styles.containerSelectAll}>
          <button className={styles.selectAllButton} onClick={handleSelectAll}>
            <CheckIcon />
            Select all {count} booking{count > 1 ? 's' : ''}
          </button>
        </div>
      </div>
    </div>
  )
}

const SelectedBookingsBar = ({ handleChangeBookingState }) => {
  const dispatch = useDispatch()

  const { selectedBookings } = useSelector(state => state.invoices)

  const bookingsOn = selectedBookings
    .filter(b => !b.isInvoicingRejected)
    .map(b => b.inviteBookingConversionDetailId)
  const bookingsOff = selectedBookings
    .filter(b => b.isInvoicingRejected)
    .map(b => b.inviteBookingConversionDetailId)

  return (
    <div className={styles.bar}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          {selectedBookings.length > 0 && (
            <>
              <Button
                className={styles.deselectAllButton}
                handleClick={() => dispatch(deselectAllBillableBookings())}
              />
              {selectedBookings.length}{' '}
              {selectedBookings.length > 1 ? 'bookings' : 'booking'} selected
            </>
          )}
          <div className={styles.toggleControls}>
            {bookingsOff.length > 0 && (
              <Control
                willCharge
                onClick={() => handleChangeBookingState(bookingsOff, true)}
              />
            )}
            {bookingsOn.length > 0 && (
              <Control onClick={() => handleChangeBookingState(bookingsOn, false)} />
            )}
            <button
              className={styles.control}
              onClick={() => dispatch(deselectAllBillableBookings())}
            >
              Clear selection
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const Control = ({ onClick, willCharge }) => (
  <button className={styles.control} onClick={onClick}>
    {willCharge ? 'Set as will charge' : `Set as won't charge`}
  </button>
)

const Button = ({ className, handleClick }) => {
  const [isHovering, setHovering] = useState()

  return (
    <button
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onClick={handleClick}
      className={className}
    >
      {isHovering ? <RemoveIcon /> : <CheckIcon />}
    </button>
  )
}

export default SelectedBookingsBar
